<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        class="transaction-search"
                        :search-condition="searchCondition"
                        :hideFuzzySearch="true"
                        :showMerchantSearch="true"
                        router-name="/report/refuse-rate">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table"
                    :table-set="tableCondition"
                    :service-function="queryList"
                    :first-parameters="firstParameters()"
                    :isPaginationDisplay="false"
                    :showMerchantNo="true"
                    router-name="/report/refuse-rate">
      </custom-table>
    </div>
  </div>
</template>
<script>
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { eventTrackManager } from '@/plugins/eventTrackManager';
import { initExhibitionTable } from '@/utils/tools/constant';
import { formatDateDisplay } from '@/utils/tools/time';
import ReportService from '@/views/report/api/report';

export default {
  components: {
    SearchComponent,
    CustomTable,
  },
  data() {
    return {
      searchCondition: [
        {
          key: ['createdDateStart', 'createdDateEnd'],
          name: 'message.tableCommon.createDate',
          type: 'date_time',
          dateType: 'month',
          dateFormat: 'yyyy-MM',
          dateValueFormat: 'yyyy-MM',
          defValue: [formatDateDisplay((new Date().setMonth((new Date()).getMonth() - 11)), 'yyyy-MM'), formatDateDisplay(new Date(), 'yyyy-MM')],
          handleClick: () => {
            eventTrackManager.send({ e: 'txnreport_creationdate' });
          },
        },
        {
          key: 'currency',
          name: 'message.tableCommon.currency',
          defValue: 'ALL',
          type: 'select',
          options: [],
          titleToolTips: 'message.report.refuseCurrencyTooltip',
          titleToolTipsKey: 'refureport_currency_tooltip',
          handleClick: () => {
            eventTrackManager.send({ e: 'txnreport_currency' });
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.createDate' },
          key: 'createdDate',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.successfulCount' },
          key: 'successTradedTotal',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.successfulAmount' },
          key: 'successTradedAmount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseCount' },
          key: 'repudiateTradedTotal',
          type: 'text',
          textFunc: (row) => (Number.isNaN(row.repudiateTradedTotal) ? 0 : Number(row.repudiateTradedTotal)),

        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseAmount' },
          key: 'repudiateTradedAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.repudiateTradedAmount) {
              return row.repudiateTradedAmount;
            }
            const { currency } = this.$route.query;
            if (currency === 'ALL' || !currency) {
              return 'USD 0';
            }
            return `${currency} 0`;
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseRate' },
          key: 'repudiateRate',
          type: 'text',
          textFunc: (row) => `${row.repudiateRate === 'null' ? '0.00%' : `${(Number(row.repudiateRate) * 100).toFixed(2)}%`}`,
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.refundAmount' },
          key: 'refundAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.refundAmount) {
              return row.refundAmount;
            }
            const { currency } = this.$route.query;
            if (currency === 'ALL' || !currency) {
              return 'USD 0';
            }
            return `${currency} 0`;
          },
        },
        {
          titleBar: { type: 'text', title: 'message.index.refundRate' },
          key: 'refundRate',
          type: 'text',
          textFunc: (row) => `${row.refundRate === 'null' ? '0.00%' : `${(Number(row.refundRate) * 100).toFixed(2)}%`}`,
        },
        {
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'buttons',
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.details',
              permissionCode: 'report:refuseRate:view',
              func: (data) => {
                this.$router.push({
                  path: '/report/refuse-rate/view',
                  query: {
                    createdDate: data.createdDate,
                    currency: this.$refs.search.getInputValue('currency'),
                    merchantNo: data.merchantNo,
                  },
                });
              },
            },
          ],
        },
        // {
        //   titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
        //   key: 'buttons',
        //   type: 'operations',
        //   subTableDisplays: [
        //     {
        //       type: 'text_button',
        //       textFunc: () => 'message.tableCommon.details',
        //       permissionCode: 'report:refuseRate:view',
        //       func: (data) => {
        //         this.$router.push({
        //           path: '/report/refuse-rate/view',
        //           query: {
        //             createdDate: data.createdDate,
        //             currency: this.$refs.search.getInputValue('currency'),
        //           },
        //         });
        //       },
        //     },
        //   ],
        // },
      ],
    };
  },
  mounted() {
    this.getCurrencyList();
    this.$nextTick(() => {
      const successReportCurrencyTooltipDom = document.querySelector('.refureport_currency_tooltip');
      successReportCurrencyTooltipDom.addEventListener('mouseenter', () => {
        console.log('鼠标移入');
        eventTrackManager.send({ e: 'txnreport_hover' });
      });
    });
  },
  methods: {
    queryList: async (params, parent) => {
      try {
        if (!params.createdDateStart || !params.createdDateEnd) {
          if (!params.createdDateStart && !params.createdDateEnd) {
            params.createdDateStart = formatDateDisplay((new Date().setMonth((new Date()).getMonth() - 11)), 'yyyy-MM');
            params.createdDateEnd = formatDateDisplay(new Date(), 'yyyy-MM');
          } else if (!params.createdDateStart) {
            params.createdDateStart = params.createdDateEnd;
          } else if (!params.createdDateEnd) {
            params.createdDateEnd = params.createdDateStart;
          }
          const query = { ...params, status: 1 };
          parent.$refs.search.sendQueryCriteria(query);
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('customerErrorHandler');
        }
        delete params.status;
        const list = await ReportService.refuseRateReport(params);
        return Promise.resolve(initExhibitionTable(list, true));
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getCurrencyList() {
      ReportService.getReportCurrency({ type: 3 }).then((res) => {
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('currency', res);
          const oldCurrency = this.$route.query.currency;
          let exist = false;
          if (oldCurrency) {
            for (let i = 0; i < res.length; i++) {
              if (res[i].value === oldCurrency) {
                exist = true;
                break;
              }
            }
          }
          if (!exist || !oldCurrency) {
            this.$refs.search.setInputValue('currency', 'ALL');
          } else {
            this.$refs.search.setInputValue('currency', oldCurrency);
          }
        }
      }).catch(() => {});
    },
    firstParameters: () => {
      return {
        createdDateStart: formatDateDisplay((new Date().setMonth((new Date()).getMonth() - 11)), 'yyyy-MM'),
        createdDateEnd: formatDateDisplay(new Date(), 'yyyy-MM'),
        currency: 'ALL',
      };
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
</style>
